import * as Immutable from 'immutable';
import {
  LIST_ADVISER_CONTACTS_REQUESTED,
  LIST_ADVISER_CONTACTS_COMPLETED,
  LIST_ADVISER_CONTACTS_FAILED,
  LIST_ADVISER_CONTACTS_ABORTED,
  RESET_ADVISER_CONTACTS_REQUESTED,
  RESET_ADVISER_CONTACTS_COMPLETED,
  SET_ADVISER_CONTACT_REQUESTED,
  SET_ADVISER_CONTACT_COMPLETED,
  SET_ADVISER_CONTACT_ABORTED,
  SET_ADVISER_CONTACT_FAILED,
  SEARCH_ADVISER_CONTACTS_REQUESTED,
  SEARCH_ADVISER_CONTACTS_COMPLETED,
  SEARCH_ADVISER_CONTACTS_FAILED,
} from '../../actions/adviserContacts/types';

const schema = {
  status: 'INIT', // INIT/OK/ERROR
  error: null,
  list: {},
  set: {},
  gettinglist: false,
  gotlist: false,
  gettingdata: false,
  gotdata: false,
  abortedlist: false,
  resettingcontacts: false,
  searchTerm: '',
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADVISER_CONTACT_REQUESTED:
      return state.set('gettingdata', true).set('set', null);

    case SET_ADVISER_CONTACT_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('set', action.payload);

    case SET_ADVISER_CONTACT_ABORTED:
      return state.set('gettingdata', false).set('gotdata', false);

    case SET_ADVISER_CONTACT_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case RESET_ADVISER_CONTACTS_REQUESTED:
      return state.set('resettingcontacts', true);

    case RESET_ADVISER_CONTACTS_COMPLETED:
      return state.set('resettingcontacts', false).set('list', {});

    case LIST_ADVISER_CONTACTS_REQUESTED:
      return state.set('error', null).set('gettinglist', true);

    case LIST_ADVISER_CONTACTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case LIST_ADVISER_CONTACTS_ABORTED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', false)
        .set('abortedlist', true);

    case LIST_ADVISER_CONTACTS_FAILED:
      return state
        .set('error', action.payload)
        .set('gettinglist', false)
        .set('list', {});

    case SEARCH_ADVISER_CONTACTS_REQUESTED:
      return state
        .set('error', null)
        .set('gettinglist', true)
        .set('searchTerm', action.payload.Search);

    case SEARCH_ADVISER_CONTACTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case SEARCH_ADVISER_CONTACTS_FAILED:
      return state
        .set('error', action.payload)
        .set('gettinglist', false)
        .set('list', {});

    default:
      return state;
  }
};

export { initialState };

export default reducer;
